import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { AuthInterceptor, CredentialsInterceptor } from 'interceptors';
import { environment } from 'util';
import { routes } from './app.routes';

const localProviderSources: any[] = [];
const environmentalProviders: any = [];
if (environment.local) {
    //localProviderSources.push(
    //    HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, {
    //        dataEncapsulation: false,
    //        delay: 2000
    //    }),
    //);
}

environmentalProviders.push(
    provideServiceWorker('service-worker.js', {
        enabled: !environment.local,
        registrationStrategy: 'registerImmediately',
        scope: '/',
    }),
);

const providers = [
    // Angular 21 bootstraps zoneless unless told otherwise. Every build target still ships the
    // zone.js polyfill and the app has not been audited for zoneless, so keep zone-based change
    // detection explicit here rather than inherit a new default.
    provideZoneChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom([
        ...localProviderSources
    ]),
    {
        provide: HTTP_INTERCEPTORS,
        useClass: CredentialsInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    },
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: {
            subscriptSizing: 'dynamic',
        }
    },
    ...environmentalProviders
];

export const appConfig: ApplicationConfig = {
    providers: providers,
};
